import { add, remove, listen, qsa } from '@fluorescent/dom';

const selectors = {
  dots: '.page-dot',
};

const pageDots = (container, slider, slideCount) => {
  const pageDots = qsa(selectors.dots, container);
  const events = [];

  pageDots.forEach(dot => {
    events.push(listen(dot, 'click', e => _handlePageDot(e)));
  });

  const _handlePageDot = e => {
    e.preventDefault();

    if (e.target.classList.contains('is-selected')) return;

    // 3 or more page dots is handled differently than 2 due to having
    // to load aditional slides because of transition animation
    if (slideCount > 2) {
      const { slideIndex } = e.target.dataset;
      slider.select(slideIndex);

      return;
    }

    // 2 slides actually loads 4 slides, however we are using
    // 2 page dots to fake only showing 2 slides.
    if (e.target.classList.contains('next')) {
      slider.next();
    } else {
      slider.previous();
    }
  };

  const update = cellIndex => {
    const activeClass = 'is-selected';

    pageDots.forEach(dot => remove(dot, activeClass));

    if (slideCount > 2) {
      add(pageDots[cellIndex], activeClass);
      return;
    }

    add(pageDots[cellIndex % 2], activeClass);
  };

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
  };

  return { update, unload };
};

export default pageDots;
